import React from 'react'
import { CommentHeader, CommentItem, CommentList, CommentText, HistoryItemText, Section, SectionTitle, InputComment, UserImage, WhatTime, InputCommentDiv } from '../style'
import { MessageSquareMore } from 'lucide-react'

const CommentsOfOp:React.FC = () => {
  return (
    <Section>
      <SectionTitle><MessageSquareMore size={20} />Comentários</SectionTitle>
      <CommentList>
        <InputCommentDiv>
          <UserImage biggest={true}>JL</UserImage>
          <InputComment
              placeholder='Comentário para esta etapa...'
              onKeyDown={() => {}}
            />
        </InputCommentDiv>
        <CommentItem>
          <CommentHeader>
            <UserImage>JL</UserImage>
            <HistoryItemText><span>João Henrique</span></HistoryItemText>
          </CommentHeader>
          <CommentText>Opa, nessa etapa aqui bora dar uma tratada na peça pq tá zoado</CommentText>
          <WhatTime>Ontem 12:20</WhatTime>
        </CommentItem>
        <CommentItem>
          <CommentHeader>
            <UserImage>JL</UserImage>
            <HistoryItemText><span>João Henrique</span></HistoryItemText>
          </CommentHeader>
          <CommentText>Opa, nessa etapa aqui bora dar uma tratada na peça pq tá zoado</CommentText>
          <WhatTime>Ontem 12:20</WhatTime>
        </CommentItem>
      </CommentList>
    </Section>
  )
}

export default CommentsOfOp